import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { SIMPLE_ALLERGEN_FRAGMENT } from '../fragments'

const ALLERGENS_QUERY = gql`
  query allergens {
    allergens {
      results {
        ...SimpleAllergenFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${SIMPLE_ALLERGEN_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default ALLERGENS_QUERY
